/* This file is autogenerated by running the src/glossDS/tokens/utils/IconsDirectoryParser.js script */
export const CUSTOM_ICONS_FILE_NAME_SET = new Set<string>([
  'card-amex',
  'card-diners',
  'card-discover',
  'card-jcb',
  'card-mastercard',
  'card-reader-outline',
  'card-unionpay',
  'card-visa',
  'gg-bottle-pump-line',
  'gg-card-clock-line',
  'gg-cellular-line',
  'gg-gloss-symbol-fill',
  'gg-gloss-word-fill',
  'gg-salon-chair-fill',
  'gg-scan-line',
  'gg-yelp-circle',
  'gg-yelp',
  'gloss-genius',
]);
